module.exports = __webpack_public_path__ + "img/sanda-3.954f7b17.png";